<template>
  <div class="flex items-start justify-start">
    <span class="info-icon"></span>
    <p v-html="errorMessage" class="flex-1 max-w-[52rem] text-base leading-5 error-message font-futuraEfBook" data-testid="searchInputErrorMessage"></p>
  </div>
</template>

<script>
export default {
  name: 'SearchInputErrorMessage',
  props: {
    errorMessage: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.error-message :deep(a) {
  @apply !text-base underline hover:!no-underline;
}
.info-icon {
  @apply not-sr-only;
}
.info-icon::before {
  @apply content-[''] block w-6 h-6 bg-newColors-orange-signature -mt-[2px] mr-2;
  mask: url('/src/assets/images/brand2024/icon-info.svg') no-repeat center / contain;
  -webkit-mask: url('/src/assets/images/brand2024/icon-info.svg') no-repeat center / contain;
}
</style>
